export enum HeaderPanel {
  ProfilePanel = 'ProfilePanel',
}
